import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
import { GetString } from '../StringResourceManager';
import {
  alertTextToCategoryMap,
  getAlertCategoryOptions,
  getAlertTypeByCategoryOptions,
} from '../../utils/textMappings';
import { ApplicationState } from '../../store';
import { useSelector } from 'react-redux';
import StringResources from '../../utils/stringResources';
import DynamicComboBox from '../DynamicComboBox';

const useStyles = makeStyles(() =>
  createStyles({
    alertCategoryInput: { width: '250px', minWidth: '5%' },
    alertNameInput: { width: '250px', minWidth: '5%', marginLeft: 10 },
  })
);

export const CustomFilterAlertsCategory = (props: any) => {
  const classes = useStyles();
  const [alertTypeData, setAlertTypeData] = React.useState<string[]>();

  const selectedLanguage: string = useSelector(
    (state: ApplicationState) => state.userSettingsReducer.selectedLanguage
  );

  const convertString = (stringKey: any) => {
    const stringResources = StringResources;
    var string: any = '';
    switch (selectedLanguage) {
      case StringResources.English.ENGLISH_OPTION:
        string = stringResources.English;
        break;
      case StringResources.English.FRENCH_OPTION:
        string = stringResources.French;
        break;
      default:
        string = stringResources.English;
        break;
    }
    return string[stringKey];
  };

  const onChangeAlertCategory = (event: any) => {
    setAlertTypeData(
      getAlertTypeByCategoryOptions(alertTextToCategoryMap(event.target.value))
    );
    props.onFilterChange.call(undefined, {
      nextFilter: {
        ...props.filter,
        value: {
          Category: event.target.value,
          Type: undefined,
        },
      },
    });
  };

  const onChangeAlertType = (event: any) => {
    props.onFilterChange.call(undefined, {
      nextFilter: {
        ...props.filter,
        value: {
          Category: props.filter.value?.Category ?? '',
          Type: event.target.value,
        },
      },
    });
  };

  return (
    <React.Fragment>
      <DynamicComboBox
        className={classes.alertCategoryInput}
        onChange={onChangeAlertCategory}
        placeholder={GetString('CATEGORY_PLACEHOLDER')}
        data={getAlertCategoryOptions()}
        value={props.filter?.value?.Category ?? ''}
      />
      <DynamicComboBox
        className={classes.alertNameInput}
        onChange={onChangeAlertType}
        data={alertTypeData?.map(option => convertString(option))}
        value={props.filter?.value?.Type ?? ''}
        placeholder={GetString('TYPE_PLACEHOLDER')}
        disabled={!props.filter?.value?.Category}
      />
    </React.Fragment>
  );
};
